export default "__VITE_ASSET__11571a9d__"